<template>
	<div class="main-containter" id="top" v-title data-title="reservaion">
		<PHeader :checkId="'荣誉奖项31'"  :activeNames="'关于我们'"></PHeader>
		
		<article>
			<div style="height:150px;width:100%">
				<img src="https://quantum-health.oss-cn-hangzhou.aliyuncs.com/lawyer/otherTitle.png" style="height: 100%;width: 100%;">
				<div class="fbannerUpText" style="position: absolute;top: 120px;color: white;font-weight: 600;font-size: 20px;left: calc(50% - 40px);">关于我们</div>
				<div class="fbannerUpText" style="position: absolute;top: 155px;color: white;font-size: 14px;left: calc(50% - 31px);">About Us</div>
			</div>
			<div style="margin-top:10px;margin-left:3%;">
				<span style="color:#AAAAAA;font-size:14px;">首页 / 关于我们</span>
				<span style="color:#333333;font-size:14px;"> / 荣誉奖项</span>
			</div>
			<div style="font-size: 22px;font-weight: 900;color: #AA1100;margin-left: 3%;margin-top:20px;">荣誉奖项</div>
			<div style="color: #AA1100;margin-left: 3%;margin-top: 5px;font-size: 14px;">Honorary Awards</div>
			<div style="margin-left: 3%;margin-top: 5px;width: 20px;height: 3px;background: #AA1100;"></div>
			<div style="width:94%;margin-left:3%;margin-bottom:30px;">
				<div style="color: rgb(152, 39, 58);margin-top: 20px;padding-bottom: 10px;font-size: 12px;border-bottom: 1px solid #CF9AA3;" v-for="(item,index) in list" :key="item+''+index">
					<span style="width: 4px;display: inline-block;height: 4px;margin-bottom: 3px;margin-left: 7px;background: rgb(152, 39, 58);"></span>
					{{item}}
				</div>
			</div>
		</article>
		<Pooter></Pooter>
	</div>
</template>

<script>
	import PHeader from "../../components/p/PHeader.vue"
	import Pooter from "../../components/p/Pooter.vue"
	export default {
		name: "Index",
		components: {
			PHeader,
			Pooter
		},
		data() {
			return {
				list: ['国家知识产权局“2021年度商标行政保护十大案例',
				'国家知识产权局“2021年度商标行政保护十大案例',
				'国家知识产权局“2021年度商标行政保护十大案例',
				'国家知识产权局“2021年度商标行政保护十大案例',
				'国家知识产权局“2021年度商标行政保护十大案例',
				'国家知识产权局“2021年度商标行政保护十大案例',
				'国家知识产权局“2021年度商标行政保护十大案例',
				'国家知识产权局“2021年度商标行政保护十大案例',
				'国家知识产权局“2021年度商标行政保护十大案例',
				'国家知识产权局“2021年度商标行政保护十大案例',
				'国家知识产权局“2021年度商标行政保护十大案例',
				'国家知识产权局“2021年度商标行政保护十大案例',
				'国家知识产权局“2021年度商标行政保护十大案例',
				'国家知识产权局“2021年度商标行政保护十大案例',
				'国家知识产权局“2021年度商标行政保护十大案例',
				'国家知识产权局“2021年度商标行政保护十大案例'],
			}
		},
		mounted() {
		},
		activated(){
			document.getElementById("top").scrollIntoView({ behavior: "smooth" });
		},
		methods: {
		}
	}
</script>

<style lang="scss" scoped>
	.indexAboutUs{
		background: url("https://quantum-health.oss-cn-hangzhou.aliyuncs.com/lawyer/phoneBusiness.png") no-repeat;
		height:100%;
		width:100%;
		overflow: hidden;
		background-size:cover;//或者background-size:1
	}
	.main-containter {
		.news{
			background-image: url(../../assets/fImage/homeNewsBg.jpg);
			background-size: cover;
		}
	}
	.main-containter ::v-deep .el-carousel__indicators--horizontal{
		display: none;
	}

	.parentCarousel ::v-deep .el-carousel__container{
		height: 100%;
	}
	body ::v-deep .v-modal{
		display: none;
	}
</style>
